import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { iconShape } from '../../../../../../../shared/types';

const InfoSection = ({ children, icon, label }) => (
  <div className="text-sm space-y-1.5">
    <h3 className="font-medium flex items-center gap-2">
      <FontAwesomeIcon icon={icon} />
      {label}
    </h3>

    <p className="text-muted-foreground">{children}</p>
  </div>
);

InfoSection.propTypes = {
  children: PropTypes.node.isRequired,
  icon: iconShape.isRequired,
  label: PropTypes.string.isRequired,
};

export default InfoSection;
